import React from 'react'
import Profile from '../../components/admin/profile/Profile'

function ProfilePage() {
  return (
  <Profile/>
  )
}

export default ProfilePage